import React, { useReducer, useState } from 'react';
import cn from 'classnames';

import IMG_1 from 'assets/images/ui/m-1.png';
import IMG_2 from 'assets/images/ui/m-2.png';
import IMG_3 from 'assets/images/ui/m-3.png';
import IMG_4 from 'assets/images/ui/m-4.png';
import IMG_5 from 'assets/images/ui/m-5.png';
import IMG_6 from 'assets/images/ui/m-6.png';
import IMG_7 from 'assets/images/ui/m-7.png';
import IMG_8 from 'assets/images/ui/m-8.png';
import IMG_9 from 'assets/images/ui/m-9.png';
import IMG_10 from 'assets/images/ui/m-10.png';
import IMG_11 from 'assets/images/ui/m-11.png';
import IMG_12 from 'assets/images/ui/m-12.png';
import IMG_13 from 'assets/images/ui/m-13.png';
import IMG_14 from 'assets/images/ui/m-14.png';
import IMG_15 from 'assets/images/ui/m-15.png';
import IMG_16 from 'assets/images/ui/m-16.png';
import IMG_17 from 'assets/images/ui/m-17.png';
import IMG_18 from 'assets/images/ui/m-18.png';
import IMG_19 from 'assets/images/ui/m-19.png';
import IMG_20 from 'assets/images/ui/m-20.png';
import SalonModal from 'components/dialog/SalonModal.component';
import Button from 'components/form/Button.component';
import CheckboxInput from 'components/form/CheckboxInput.component';
import Icon from 'components/generic/Icon.component';
import IconStatus from 'components/generic/IconStatus.component';
import Space from 'components/generic/Space.component';
import CurrencySign from 'components/price/CurrencySign.component';
import RebookAppointmentModal from 'components/sidebar/appointment/dialogs/RebookAppointmentModal.component';
import CHARGE_TYPE from 'constants/payment/chargeType.const';
import DEPOSIT_SOURCE from 'constants/payment/depositSource.const';
import S from 'constants/string.const';
import alwaysNoop from 'utils/functions/nullary/alwaysNoop.util';
import asObject from 'utils/objects/asObject.util';

import SM from './ModalsPanel.module.scss';
import CN from './UiPage.module.scss';

// Since this is experiment, we can share the same .module.scss file

const modalsReducer = (state, action) => {
  if (action.type === 'show') {
    return { ...state, [action.modal]: true };
  }

  if (action.type === 'hide') {
    return { ...state, [action.modal]: false };
  }

  return state;
};

const ModalsPanel = () => {
  const [modalsState, dispatch] = useReducer(modalsReducer, asObject());

  const showModal = (modal) => dispatch({ type: 'show', modal });
  const hideModal = (modal) => dispatch({ type: 'hide', modal });

  const [chargeType, setChargeType] = useState(CHARGE_TYPE.noShowBank);
  const [sourceType] = useState(DEPOSIT_SOURCE.card);

  const handleRadioChange = (event) => {
    const newValue = event.currentTarget.getAttribute('data-value');
    setChargeType(newValue);
  };

  return (
    <div data-bem="ModalsPanel" className={CN.flexColumns}>
      <div data-bem="column-left">
        <div className={CN.preview}>
          <div onClick={() => showModal('modal_1')} className={CN.imgNumber}>
            <div className={CN.number}>1</div>
            <img src={IMG_1} alt="" className={CN.imgPreview} />
          </div>
          <SalonModal tag="ModalsPanel__modal_1" isOpen={modalsState.modal_1} withFooter isHighlighted onClose={() => hideModal('modal_1')}>
            <SalonModal.Body>
              <IconStatus variant="warning" width="lg">
                <Icon variant="bin" selected width="l1" />
              </IconStatus>
              <div className={SM.modalContent}>
                <div className={SM.modalTitle}>Delete this booking?</div>
                <div className={SM.modalText}>This will remove the booking from your diary. To undo this, you would need to contact customer support.</div>
              </div>
            </SalonModal.Body>
            <SalonModal.Footer>
              <div className={SM.modalButtons}>
                <Button variant="outlineForce" onClick={() => hideModal('modal_1')}>
                  GO BACK
                </Button>
                <Button variant="alert" onClick={alwaysNoop} xSpace>
                  DELETE BOOKING
                </Button>
              </div>
            </SalonModal.Footer>
          </SalonModal>
        </div>

        <div className={CN.preview}>
          <div onClick={() => showModal('modal_2')} className={CN.imgNumber}>
            <div className={CN.number}>2</div>
            <img src={IMG_2} alt="" className={CN.imgPreview} />
          </div>
          <SalonModal tag="ModalsPanel__modal_2" isOpen={modalsState.modal_2} withFooter onClose={() => hideModal('modal_2')}>
            <SalonModal.Body>
              <IconStatus variant="alert" width="lg">
                <Icon variant="alert" width="l1" />
              </IconStatus>
              <div className={SM.modalContent}>
                <div className={SM.modalTitle}>You are about to change the status of this appointment from from Status to toStatus</div>
                <div className={SM.textAlert}>Your chosen option for deposit (if applicable) will NOT change</div>
              </div>
            </SalonModal.Body>
            <SalonModal.Footer>
              <div className={SM.modalButtons}>
                <Button variant="outlineForce" xSpace onClick={() => hideModal('modal_2')}>
                  GO BACK
                </Button>
                <Button variant="primaryForce" xSpace onClick={alwaysNoop}>
                  CHANGE STATUS
                </Button>
              </div>
            </SalonModal.Footer>
          </SalonModal>
        </div>

        <div className={CN.preview}>
          <div onClick={() => showModal('modal_3')} className={CN.imgNumber}>
            <div className={CN.number}>3</div>
            <img src={IMG_3} alt="" className={CN.imgPreview} />
          </div>
          <SalonModal tag="ModalsPanel__modal_3" isOpen={modalsState.modal_3} withFooter isHighlighted onClose={() => hideModal('modal_3')}>
            <SalonModal.Body>
              <IconStatus variant="warning" width="lg">
                <Icon variant="calendarEmptyRed" selected width="l1" />
              </IconStatus>
              <div className={SM.modalContent}>
                <div className={SM.modalTitle}>Confirm appointment cancellation</div>
                <div className={SM.modalText}>This slot will become available for other clients to book.</div>
                <div className={SM.textAlert}>Get protection from last minute cancellations by enabling Online Deposits in Online Booking & Payments.</div>
              </div>
            </SalonModal.Body>
            <SalonModal.Footer>
              <div className={SM.modalButtons}>
                <Button variant="outlineForce" onClick={() => hideModal('modal_3')} xSpace>
                  GO BACK
                </Button>
                <Button variant="alert" onClick={alwaysNoop} xSpace>
                  CANCEL APPOINTMENT
                </Button>
              </div>
            </SalonModal.Footer>
          </SalonModal>
        </div>

        <div className={CN.preview}>
          <div onClick={() => showModal('modal_4')} className={CN.imgNumber}>
            <div className={CN.number}>4</div>
            <img src={IMG_4} alt="" className={CN.imgPreview} />
          </div>
          <SalonModal tag="ModalsPanel__modal_4" isOpen={modalsState.modal_4} withFooter isHighlighted onClose={() => hideModal('modal_4')}>
            <SalonModal.Body>
              <IconStatus variant="warning" width="lg">
                <Icon variant="handDownRed" width="l1" />
              </IconStatus>
              <div className={SM.modalContent}>
                <div className={SM.modalTitle}>Confirm no-show</div>
                <div className={SM.modalText}>This slot will become available for other clients to book.</div>
                <div className={SM.textAlert}>Get protection from last minute cancellations by enabling Online Deposits in Online Booking & Payments.</div>
              </div>
            </SalonModal.Body>
            <SalonModal.Footer>
              <div className={SM.modalButtons}>
                <Button variant="outlineForce" onClick={() => hideModal('modal_4')} xSpace>
                  GO BACK
                </Button>
                <Button variant="alert" onClick={alwaysNoop} xSpace>
                  MARK AS NO-SHOW
                </Button>
              </div>
            </SalonModal.Footer>
          </SalonModal>
        </div>

        <div className={CN.preview}>
          <div onClick={() => showModal('modal_5')} className={CN.imgNumber}>
            <div className={CN.number}>5</div>
            <img src={IMG_5} alt="" className={CN.imgPreview} />
          </div>
          <SalonModal tag="ModalsPanel__modal_5" isOpen={modalsState.modal_5} withFooter onClose={() => hideModal('modal_5')}>
            <SalonModal.Header>
              <div className={SM.closeButtonContainer}>
                <Button variant="empty" onClick={() => hideModal('modal_5')}>
                  <Icon variant="close" variantInvert />
                </Button>
              </div>
            </SalonModal.Header>
            <SalonModal.Body>
              <IconStatus variant="warning" width="lg">
                <Icon variant="arrowPath" selected width="l1" />
              </IconStatus>
              <div className={SM.modalContent}>
                <div className={SM.modalTitle}>Delete repeat booking</div>
                <div
                  className={cn({
                    [SM.modalText]: true,
                    [SM.widthSm]: true,
                  })}
                >
                  You can delete all of the repeated bookings OR this selected booking
                </div>
              </div>
            </SalonModal.Body>
            <SalonModal.Footer>
              <div className={SM.modalButtons}>
                <Button tag="ModalsPanel__delete-all-button--m5" variant="outlineForce" onClick={alwaysNoop} xSpace>
                  DELETE ALL
                </Button>
                <Button variant="alert" onClick={alwaysNoop} xSpace>
                  DELETE SELECTED ONLY
                </Button>
              </div>
            </SalonModal.Footer>
          </SalonModal>
        </div>

        <div className={CN.preview}>
          <div onClick={() => showModal('modal_14')} className={CN.imgNumber}>
            <div className={CN.number}>14</div>
            <img src={IMG_14} alt="" className={CN.imgPreview} />
          </div>
          <SalonModal tag="ModalsPanel__modal_14" isOpen={modalsState.modal_14} withFooter onClose={() => hideModal('modal_14')}>
            <SalonModal.Body>
              <IconStatus variant="alert" width="lg">
                <Icon variant="alert" width="l1" />
              </IconStatus>
              <div className={SM.modalContent}>
                <div className={SM.modalTitle}>Refund deposit</div>
                <div className={SM.modalText}>You are about to refund a deposit of</div>
                <div className={SM.modalBigText}>
                  <CurrencySign value="4.00" />
                </div>
                <div className={SM.modalText}>
                  {sourceType === DEPOSIT_SOURCE.card && 'via card machine in-store.'}
                  {(sourceType === DEPOSIT_SOURCE.cash || sourceType === DEPOSIT_SOURCE.online) && 'to the client in cash.'}
                  {sourceType === DEPOSIT_SOURCE.other && 'to the client in other.'}
                </div>
              </div>
            </SalonModal.Body>
            <SalonModal.Footer>
              <div className={SM.modalButtons}>
                <Button variant="outlineForce" onClick={() => hideModal('modal_14')}>
                  CANCEL
                </Button>
                <Button variant="alert" onClick={alwaysNoop} xSpace>
                  CONFIRM
                </Button>
              </div>
            </SalonModal.Footer>
          </SalonModal>
        </div>

        <div className={CN.preview}>
          <div onClick={() => showModal('modal_16')} className={CN.imgNumber}>
            <div className={CN.number}>16</div>
            <img src={IMG_16} alt="" className={CN.imgPreview} />
          </div>
          <SalonModal tag="ModalsPanel__modal_16" isOpen={modalsState.modal_16} withFooter isHighlighted onClose={() => hideModal('modal_16')}>
            <SalonModal.Header>
              <div className={SM.closeButtonContainer}>
                <Button variant="empty" onClick={() => hideModal('modal_16')}>
                  <Icon variant="close" variantInvert />
                </Button>
              </div>
            </SalonModal.Header>
            <SalonModal.Body>
              <IconStatus variant="warning" width="lg">
                <Icon variant="arrowPath" selected width="l1" />
              </IconStatus>
              <div className={SM.modalContent}>
                <div className={SM.modalTitle}>Delete repeat booking</div>
                <div
                  className={cn({
                    [SM.modalText]: true,
                    [SM.widthSm]: true,
                  })}
                >
                  You can delete all of the repeated bookings OR this selected booking
                </div>
              </div>
            </SalonModal.Body>
            <SalonModal.Footer>
              <div
                className={cn({
                  [SM.modalButtons]: true,
                  [SM.right]: true,
                })}
              >
                <Button tag="ModalsPanel__delete-all-button--m16" variant="alertOutline" onClick={alwaysNoop} xSpace>
                  DELETE ALL
                </Button>
                <Button variant="alert" onClick={alwaysNoop} xSpace>
                  DELETE SELECTED ONLY
                </Button>
              </div>
            </SalonModal.Footer>
          </SalonModal>
        </div>
      </div>

      <div data-bem="column-middle">
        <div className={CN.preview}>
          <div onClick={() => showModal('modal_10')} className={CN.imgNumber}>
            <div className={CN.number}>10</div>
            <img src={IMG_10} alt="" className={CN.imgPreview} />
          </div>
          <SalonModal tag="ModalsPanel__modal_10" isOpen={modalsState.modal_10} withFooter onClose={() => hideModal('modal_10')}>
            <SalonModal.Header>
              <div className={SM.closeButtonContainer}>
                <Button variant="empty" onClick={() => hideModal('modal_10')}>
                  <Icon variant="close" variantInvert />
                </Button>
              </div>
            </SalonModal.Header>
            <SalonModal.Body>
              <IconStatus width="lg" position="left" variant="warning">
                <Icon width="l1" variant="bin" />
              </IconStatus>

              <div
                className={cn({
                  [SM.modalContent]: true,
                  [SM.left]: true,
                })}
              >
                <div className={SM.modalTitle}>Appointment deleted</div>
                <div className={SM.modalText}>
                  Next steps:
                  <div className={SM.modalBullet}>{S.dot} Re-book the client for a future date</div>
                  <div className={SM.modalBullet}>{S.dot} Send SMS to confirm cancellation and invite them to re-book</div>
                </div>
              </div>
            </SalonModal.Body>
            <SalonModal.Footer>
              <div
                className={cn({
                  [SM.modalButtons]: true,
                  [SM.right]: true,
                })}
              >
                <Button variant="outlineForce" onClick={alwaysNoop} xSpace>
                  RE-BOOK NOW
                </Button>
                <Button variant="primaryForce" onClick={alwaysNoop} xSpace>
                  SEND RE-BOOK SMS
                </Button>
              </div>
            </SalonModal.Footer>
          </SalonModal>
        </div>

        <div className={CN.preview}>
          <div onClick={() => showModal('modal_6')} className={CN.imgNumber}>
            <div className={CN.number}>6</div>
            <img src={IMG_6} alt="" className={CN.imgPreview} />
          </div>
          <SalonModal tag="ModalsPanel__modal_6" isOpen={modalsState.modal_6} withFooter onClose={() => hideModal('modal_6')}>
            <SalonModal.Header>
              <div className={SM.closeButtonContainer}>
                <Button variant="empty" onClick={() => hideModal('modal_6')}>
                  <Icon variant="close" variantInvert />
                </Button>
              </div>
            </SalonModal.Header>
            <SalonModal.Body>
              <IconStatus width="lg" position="left" variant="warning">
                <Icon selected width="l1" variant="calendarEmptyRed" />
              </IconStatus>

              <div
                className={cn({
                  [SM.modalContent]: true,
                  [SM.left]: true,
                })}
              >
                <div className={SM.modalTitle}>Appointment cancelled</div>
                <div className={SM.modalText}>
                  Next steps:
                  <div className={SM.modalBullet}>{S.dot} Re-book the client for a future date</div>
                  <div className={SM.modalBullet}>{S.dot} Send SMS to confirm cancellation and invite them to re-book</div>
                </div>
              </div>
            </SalonModal.Body>
            <SalonModal.Footer>
              <div
                className={cn({
                  [SM.modalButtons]: true,
                  [SM.right]: true,
                })}
              >
                <Button variant="outlineForce" onClick={alwaysNoop} xSpace>
                  RE-BOOK NOW
                </Button>
                <Button variant="primaryForce" onClick={alwaysNoop} xSpace>
                  SEND RE-BOOK SMS
                </Button>
              </div>
            </SalonModal.Footer>
          </SalonModal>
        </div>

        <div className={CN.preview}>
          <div onClick={() => showModal('modal_11')} className={CN.imgNumber}>
            <div className={CN.number}>11</div>
            <img src={IMG_11} alt="" className={CN.imgPreview} />
          </div>
          <SalonModal tag="ModalsPanel__modal_11" isOpen={modalsState.modal_11} withFooter onClose={() => hideModal('modal_11')}>
            <SalonModal.Header>
              <div className={SM.closeButtonContainer}>
                <Button variant="empty" onClick={() => hideModal('modal_11')}>
                  <Icon variant="close" variantInvert />
                </Button>
              </div>
            </SalonModal.Header>
            <SalonModal.Body>
              <IconStatus width="lg" position="left" variant="warning">
                <Icon variant="handDownRed" width="l1" />
              </IconStatus>

              <div
                className={cn({
                  [SM.modalContent]: true,
                  [SM.left]: true,
                })}
              >
                <div className={SM.modalTitle}>Appointment marked as no-show</div>
                <div className={SM.modalText}>
                  Next steps:
                  <div className={SM.modalBullet}>{S.dot} Re-book the client for a future date</div>
                  <div className={SM.modalBullet}>{S.dot} Send SMS to confirm cancellation and invite them to re-book</div>
                </div>
              </div>
            </SalonModal.Body>
            <SalonModal.Footer>
              <div
                className={cn({
                  [SM.modalButtons]: true,
                  [SM.right]: true,
                })}
              >
                <Button variant="outlineForce" onClick={alwaysNoop} xSpace>
                  RE-BOOK NOW
                </Button>
                <Button variant="primaryForce" onClick={alwaysNoop} xSpace>
                  SEND RE-BOOK SMS
                </Button>
              </div>
            </SalonModal.Footer>
          </SalonModal>
        </div>

        <div className={CN.preview}>
          <div onClick={() => showModal('modal_7')} className={CN.imgNumber}>
            <div className={CN.number}>7</div>
            <img src={IMG_7} alt="" className={CN.imgPreview} />
          </div>
          <SalonModal tag="ModalsPanel__modal_7" isOpen={modalsState.modal_7} withFooter onClose={() => hideModal('modal_7')}>
            <SalonModal.Header>
              <div className={SM.closeButtonContainer}>
                <Button variant="empty" onClick={() => hideModal('modal_7')}>
                  <Icon variant="close" variantInvert />
                </Button>
              </div>
            </SalonModal.Header>
            <SalonModal.Body>
              <IconStatus width="lg" position="left" variant="success">
                <Icon selected width="l1" variant="confirm" />
              </IconStatus>

              <div
                className={cn({
                  [SM.modalContent]: true,
                  [SM.left]: true,
                })}
              >
                <div className={SM.modalTitle}>No-show fee charged successfully</div>
                <div className={SM.modalText}>
                  <div className={SM.textAlert}>
                    <div className={SM.textBold}>
                      <CurrencySign value="12.50" />
                    </div>
                    <Space>has been charged to your client’s card on file and will appear in your revenue reports as a no-show fee</Space>
                  </div>
                </div>
                <div className={SM.modalText}>
                  Next steps:
                  <div className={SM.modalBullet}>{S.dot} Re-book the client for a future date</div>
                  <div className={SM.modalBullet}>{S.dot} Send SMS to confirm cancellation and invite them to re-book</div>
                </div>
              </div>
            </SalonModal.Body>
            <SalonModal.Footer>
              <div
                className={cn({
                  [SM.modalButtons]: true,
                  [SM.right]: true,
                })}
              >
                <Button variant="outlineForce" onClick={alwaysNoop} xSpace>
                  RE-BOOK NOW
                </Button>
                <Button variant="primaryForce" onClick={alwaysNoop} xSpace>
                  SEND RE-BOOK SMS
                </Button>
              </div>
            </SalonModal.Footer>
          </SalonModal>
        </div>

        <div className={CN.preview}>
          <div onClick={() => showModal('modal_8')} className={CN.imgNumber}>
            <div className={CN.number}>8</div>
            <img src={IMG_8} alt="" className={CN.imgPreview} />
          </div>
          <SalonModal tag="ModalsPanel__modal_8" isOpen={modalsState.modal_8} withFooter onClose={() => hideModal('modal_8')}>
            <SalonModal.Header>
              <div className={SM.closeButtonContainer}>
                <Button variant="empty" onClick={() => hideModal('modal_8')}>
                  <Icon variant="close" variantInvert />
                </Button>
              </div>
            </SalonModal.Header>
            <SalonModal.Body>
              <div
                className={cn({
                  [SM.modalContent]: true,
                  [SM.left]: true,
                })}
              >
                <IconStatus variant="info" width="lg" position="left">
                  <Icon variant="pay" selected width="lg" />
                </IconStatus>
                <div className={SM.modalTitle}>This booking has Slick no-show protection enabled</div>
                <div className={SM.modalText}>Enter an amount of your choice and Slick will charge the client{S.apos}s card on your behalf.</div>
                <div className={SM.modalSubTitle}>
                  Total booking price:
                  <div className={SM.highlighted}>
                    <CurrencySign value="12.50" />
                  </div>
                </div>

                <div className={SM.inputRow}>
                  <div className={SM.option} onClick={alwaysNoop} role="button" tabIndex={0}>
                    <Icon variant="radioCheck" selected={true} width="lg" />
                    <span className={SM.label}>
                      Fixed (<CurrencySign />)
                    </span>
                  </div>

                  <input className={SM.input} type="number" value={true} onChange={alwaysNoop} onBlur={alwaysNoop} placeholder="Enter amount" step="0.1" max={40.0} />
                </div>
                <div className={SM.inputRow}>
                  <div className={SM.option} onClick={alwaysNoop} role="button" tabIndex={0}>
                    <Icon variant="radioCheck" selected={false} width="lg" />
                    <span className={SM.label}>Percentage (%)</span>
                  </div>

                  <input className={SM.input} type="number" value={''} onChange={alwaysNoop} onBlur={alwaysNoop} placeholder="%" step="0.10" max="100" disabled />
                </div>
                <div className={SM.message}>Message...</div>
                <div className={SM.error}>Error...</div>
              </div>
            </SalonModal.Body>
            <SalonModal.Footer>
              <div className={SM.modalButtons}>
                <Button variant="outlineForce" onClick={alwaysNoop} xSpace>
                  DON{S.apos}T CHARGE
                </Button>
                <Button variant="primaryForce" onClick={alwaysNoop} disabled xSpace>
                  CHARGE CLIENT
                </Button>
              </div>
            </SalonModal.Footer>
          </SalonModal>
        </div>

        <div className={CN.preview}>
          <div onClick={() => showModal('modal_9')} className={CN.imgNumber}>
            <div className={CN.number}>9</div>
            <img src={IMG_9} alt="" className={CN.imgPreview} />
          </div>
          <SalonModal tag="ModalsPanel__modal_9" isOpen={modalsState.modal_9} withFooter onClose={() => hideModal('modal_9')}>
            <SalonModal.Body>
              <IconStatus variant="alert" width="lg">
                <Icon variant="alert" width="l1" />
              </IconStatus>
              <div className={SM.modalText}>
                <div className={SM.modalTextBig}>
                  <Space>
                    Are you sure you want to <div className={SM.modalTexError}>refund</div> the deposit of
                  </Space>
                  <div className={SM.modalTexFocused}>
                    <CurrencySign value="4.00" />
                  </div>
                  to the client’s card ending 4242.
                </div>
              </div>
            </SalonModal.Body>
            <SalonModal.Footer>
              <div className={SM.modalButtons}>
                <Button variant="outlineForce" onClick={() => hideModal('modal_9')} xSpace>
                  GO BACK
                </Button>
                <Button variant="primaryForce" onClick={alwaysNoop} xSpace>
                  REFUND DEPOSIT
                </Button>
              </div>
            </SalonModal.Footer>
          </SalonModal>
        </div>
      </div>

      <div data-bem="column-right">
        <div className={CN.preview}>
          <div onClick={() => showModal('modal_12')} className={CN.imgNumber}>
            <div className={CN.number}>12</div>
            <img src={IMG_12} alt="" className={CN.imgPreview} />
          </div>
          <SalonModal tag="ModalsPanel__modal_12" isOpen={modalsState.modal_12} withFooter onClose={() => hideModal('modal_12')}>
            <SalonModal.Body>
              <IconStatus variant="info" width="lg">
                <Icon variant="currency" width="l1" variantInvertDark />
              </IconStatus>
              <div className={SM.modalContent}>
                <div className={SM.modalTitle}>
                  User Name has paid a deposit of
                  <div className={SM.highlighted}>
                    <CurrencySign value="4.00" />
                  </div>
                </div>
                <div className={SM.modalText}>Would you like to:</div>
                <br />
                <div
                  data-value={CHARGE_TYPE.noShowBank}
                  onClick={(event) => handleRadioChange(event)}
                  className={cn({
                    [SM.checkboxContainer]: true,
                    [SM.selected]: chargeType === CHARGE_TYPE.noShowBank,
                  })}
                >
                  <CheckboxInput variant="option" checked={chargeType === CHARGE_TYPE.noShowBank}>
                    <span className={SM.cbText}>Keep the deposit as a no-show fee</span>
                  </CheckboxInput>
                </div>
                <div
                  data-value={CHARGE_TYPE.keep}
                  onClick={(event) => handleRadioChange(event)}
                  className={cn({
                    [SM.checkboxContainer]: true,
                    [SM.selected]: chargeType === CHARGE_TYPE.keep,
                  })}
                >
                  <CheckboxInput variant="option" checked={chargeType === CHARGE_TYPE.keep}>
                    <span className={SM.cbText}>Hold the deposit as credit on the client’s account for future use</span>
                  </CheckboxInput>
                </div>
                <div
                  data-value={CHARGE_TYPE.refund}
                  onClick={(event) => handleRadioChange(event)}
                  className={cn({
                    [SM.checkboxContainer]: true,
                    [SM.selected]: chargeType === CHARGE_TYPE.refund,
                  })}
                >
                  <CheckboxInput variant="option" checked={chargeType === CHARGE_TYPE.refund}>
                    <span className={SM.cbText}>Refund the deposit</span>
                  </CheckboxInput>
                </div>
              </div>
            </SalonModal.Body>
            <SalonModal.Footer>
              <div className={SM.modalButtons}>
                <Button variant="outlineForce" onClick={() => hideModal('modal_12')} xSpace>
                  CANCEL
                </Button>
                <Button variant="primaryForce" onClick={alwaysNoop} xSpace>
                  CONFIRM
                </Button>
              </div>
            </SalonModal.Footer>
          </SalonModal>
        </div>

        <div className={CN.preview}>
          <div onClick={() => showModal('modal_13')} className={CN.imgNumber}>
            <div className={CN.number}>13</div>
            <img src={IMG_13} alt="" className={CN.imgPreview} />
          </div>
          <SalonModal tag="ModalsPanel__modal_13" isOpen={modalsState.modal_13} withFooter onClose={() => hideModal('modal_13')}>
            <SalonModal.Header>
              <div className={SM.closeButtonContainer}>
                <Button variant="empty" onClick={() => hideModal('modal_13')}>
                  <Icon variant="close" variantInvert />
                </Button>
              </div>
            </SalonModal.Header>
            <SalonModal.Body>
              <IconStatus position="left" variant="info" width="lg">
                <Icon variant="currency" width="l1" variantInvertDark />
              </IconStatus>
              <div
                className={cn({
                  [SM.modalContent]: true,
                  [SM.left]: true,
                })}
              >
                <div className={SM.modalTitle}>Cancellation fee charged successfully</div>
                <div className={SM.modalText}>
                  This appointment is now <div className={SM.errorBold}>cancelled</div>. This will be recorded as a cancellation in reports. Now you can:
                </div>
                <div className={SM.modalText}>
                  Next steps:
                  <div className={SM.modalBullet}>{S.dot} Re-book the client for a future date</div>
                  <div className={SM.modalBullet}>{S.dot} Send SMS to confirm cancellation and invite them to re-book</div>
                  <div className={SM.modalBullet}>{S.dot} Press X in the top corner to return to diary</div>
                </div>
              </div>
            </SalonModal.Body>
            <SalonModal.Footer>
              <div
                className={cn({
                  [SM.modalButtons]: true,
                  [SM.right]: true,
                })}
              >
                <Button variant="outlineForce" onClick={alwaysNoop} xSpace>
                  RE-BOOK NOW
                </Button>
                <Button variant="primaryForce" onClick={alwaysNoop} xSpace>
                  SEND RE-BOOK SMS
                </Button>
              </div>
            </SalonModal.Footer>
          </SalonModal>
        </div>

        <div className={CN.preview}>
          <div onClick={() => showModal('modal_15')} className={CN.imgNumber}>
            <div className={CN.number}>15</div>
            <img src={IMG_15} alt="" className={CN.imgPreview} />
          </div>
          <SalonModal tag="ModalsPanel__modal_15" isOpen={modalsState.modal_15} withFooter onClose={() => hideModal('modal_15')}>
            <SalonModal.Body>
              <IconStatus variant="alert" width="lg">
                <Icon variant="alert" width="l1" />
              </IconStatus>
              <div className={SM.modalContent}>
                <div className={SM.modalTitle}>Exit without saving?</div>
                <div className={SM.modalText}>If you exit now, any changes will not be saved. Are you sure you want to exit?</div>
              </div>
            </SalonModal.Body>
            <SalonModal.Footer>
              <div className={SM.modalButtons}>
                <Button variant="outlineForce" xSpace onClick={() => hideModal('modal_15')}>
                  GO BACK
                </Button>
                <Button variant="primaryForce" xSpace onClick={alwaysNoop}>
                  YES, EXIT
                </Button>
              </div>
            </SalonModal.Footer>
          </SalonModal>
        </div>

        <div className={CN.preview}>
          <div onClick={() => showModal('modal_17')} className={CN.imgNumber}>
            <div className={CN.number}>17</div>
            <img src={IMG_17} alt="" className={CN.imgPreview} />
          </div>
          <SalonModal tag="ModalsPanel__modal_17" isOpen={modalsState.modal_17} withFooter onClose={() => hideModal('modal_17')}>
            <SalonModal.Header>
              <div className={SM.closeButtonContainer}>
                <Button variant="empty" onClick={() => hideModal('modal_17')}>
                  <Icon variant="close" variantInvert />
                </Button>
              </div>
            </SalonModal.Header>
            <SalonModal.Body>
              <IconStatus variant="info" width="lg">
                <Icon variant="calendarEmpty" selected width="l1" variantInvertDark />
              </IconStatus>
              <div className={SM.modalContent}>
                <div className={SM.modalTitle}>Re-book next appointment?</div>
                <div className={SM.modalText}>By re-booking before checkout, your client will have their next appointment details in their email.</div>
              </div>
            </SalonModal.Body>
            <SalonModal.Footer>
              <div
                className={cn({
                  [SM.modalButtons]: true,
                  [SM.right]: true,
                })}
              >
                <Button variant="outlineForce" onClick={alwaysNoop} xSpace>
                  RE-BOOK NOW
                </Button>
                <Button variant="primaryForce" onClick={alwaysNoop} xSpace>
                  SEND RE-BOOK SMS
                </Button>
              </div>
            </SalonModal.Footer>
          </SalonModal>
        </div>

        <div className={CN.preview}>
          <div onClick={() => showModal('modal_18')} className={CN.imgNumber}>
            <div className={CN.number}>18</div>
            <img src={IMG_18} alt="" className={CN.imgPreview} />
          </div>
          <SalonModal tag="ModalsPanel__modal_18" isOpen={modalsState.modal_18} withFooter onClose={() => hideModal('modal_18')}>
            <SalonModal.Body>
              <IconStatus variant="info" width="lg">
                <Icon variant="arrowPath" unselected width="l1" />
              </IconStatus>
              <div className={SM.modalContent}>
                <div className={SM.modalTitle}>This is a repeat booking</div>
                <div className={SM.modalText}>Your edit will only be applied to the current booking.</div>
              </div>
            </SalonModal.Body>
            <SalonModal.Footer>
              <div
                className={cn({
                  [SM.modalButtons]: true,
                  [SM.right]: true,
                })}
              >
                <Button variant="primaryForce" onClick={() => hideModal('modal_18')} xSpace>
                  OKAY
                </Button>
              </div>
            </SalonModal.Footer>
          </SalonModal>
        </div>
        <div className={CN.preview}>
          <div onClick={() => showModal('modal_19')} className={CN.imgNumber}>
            <div className={CN.number}>19</div>
            <img src={IMG_19} alt="" className={CN.imgPreview} />
          </div>

          <RebookAppointmentModal tag="ModalsPanel__modal_19" isOpen={modalsState.modal_19} onCheckout={alwaysNoop} onView={() => hideModal('modal_19')} onToday={alwaysNoop} />
        </div>
        <div className={CN.preview}>
          <div onClick={() => showModal('modal_20')} className={CN.imgNumber}>
            <div className={CN.number}>20</div>
            <img src={IMG_20} alt="" className={CN.imgPreview} />
          </div>
          <SalonModal tag="ModalsPanel__modal_20" isOpen={modalsState.modal_20} variant="noFooter" onClose={() => hideModal('modal_20')}>
            <SalonModal.Header>
              <div className={SM.closeButtonContainer}>
                <Button variant="empty" onClick={() => hideModal('modal_20')}>
                  <Icon variant="close" variantInvert />
                </Button>
              </div>
            </SalonModal.Header>
            <SalonModal.Body>
              <IconStatus width="lg" variant="success">
                <Icon selected width="l1" variant="confirm" />
              </IconStatus>

              <div className={SM.modalContent}>
                <div className={SM.modalTitle}>Variant without footer</div>

                <div className={SM.modalText}>
                  Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s
                </div>
              </div>
            </SalonModal.Body>
          </SalonModal>
        </div>
      </div>
    </div>
  );
};
// noinspection JSUnusedGlobalSymbols
export default ModalsPanel;
